var _a;
const u = up.util;
up.RenderJob = (_a = class RenderJob {
        constructor(renderOptions) {
            this.renderOptions = renderOptions;
        }
        execute() {
            this._rendered = this._executePromise();
            return this;
        }
        async _executePromise() {
            try {
                this._emitGuardEvent();
                this.renderOptions = up.RenderOptions.preprocess(this.renderOptions);
                up.browser.assertConfirmed(this.renderOptions);
                up.RenderOptions.assertContentGiven(this.renderOptions);
                let result = await this._getChange().execute();
                this._handleResult(result);
                return result;
            }
            catch (resultOrError) {
                this._handleResult(resultOrError) || this._handleError(resultOrError);
                throw resultOrError;
            }
        }
        _handleResult(result) {
            if (result instanceof up.RenderResult) {
                let { onRendered, onFinished } = result.renderOptions;
                if (!result.none)
                    up.error.guard(() => onRendered?.(result));
                let guardedOnFinished = function (result) {
                    up.error.guard(() => onFinished?.(result));
                };
                this.finished.then(guardedOnFinished, u.noop);
                return true;
            }
        }
        _handleError(error) {
            let prefix = error instanceof up.Aborted ? 'Rendering was aborted' : 'Error while rendering';
            up.puts('up.render()', `${prefix}: ${error.name}: ${error.message}`);
            up.error.guard(() => this.renderOptions.onError?.(error));
        }
        get finished() {
            return this._awaitFinished();
        }
        async _awaitFinished() {
            try {
                let result = await this._rendered;
                return await result.finished;
            }
            catch (error) {
                if (error instanceof up.RenderResult) {
                    throw await error.finished;
                }
                else {
                    throw error;
                }
            }
        }
        _getChange() {
            let handleAbort = u.memoize((request) => this._handleAbortOption(request));
            let renderOptions = { ...this.renderOptions, handleAbort };
            if (renderOptions.url) {
                return new up.Change.FromURL(renderOptions);
            }
            else if (renderOptions.response) {
                return new up.Change.FromResponse(renderOptions);
            }
            else {
                return new up.Change.FromContent(renderOptions);
            }
        }
        _emitGuardEvent() {
            let guardEvent = u.pluckKey(this.renderOptions, 'guardEvent');
            if (guardEvent) {
                guardEvent.renderOptions = this.renderOptions;
                if (up.emit(guardEvent, { target: this.renderOptions.origin }).defaultPrevented) {
                    throw new up.Aborted(`Rendering was prevented by ${guardEvent.type} listener`);
                }
            }
        }
        _handleAbortOption({ bindFragments, bindLayer, origin, layer, request }) {
            let { abort } = this.renderOptions;
            if (!abort)
                return;
            let abortOptions = {
                except: request,
                logOnce: ['up.render()', 'Change with { abort } option will abort other requests'],
                newLayer: (layer === 'new'),
                origin,
                jid: this.renderOptions.jid,
            };
            if (abort === 'target') {
                up.fragment.abort(bindFragments, { ...abortOptions });
            }
            else if (abort === 'layer') {
                up.fragment.abort({ ...abortOptions, layer: bindLayer });
            }
            else if (abort === 'all' || abort === true) {
                up.fragment.abort({ ...abortOptions, layer: 'any' });
            }
            else if (u.isFunction(abort)) {
                abort(abortOptions);
            }
            else {
                up.fragment.abort(abort, { ...abortOptions, layer: bindLayer });
            }
        }
    },
    (() => {
        u.delegatePromise(_a.prototype, function () { return this._rendered; });
        u.memoizeMethod(_a.prototype, {
            _awaitFinished: true,
            _getChange: true,
        });
    })(),
    _a);
